/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Emailverified1Inputs */

const en_emailverified1 = /** @type {(inputs: Emailverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email Verified!`)
};

const de_emailverified1 = /** @type {(inputs: Emailverified1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail verifiziert!`)
};

/**
* | output |
* | --- |
* | "Email Verified!" |
*
* @param {Emailverified1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const emailverified1 = /** @type {((inputs?: Emailverified1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Emailverified1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_emailverified1(inputs)
	return de_emailverified1(inputs)
});
export { emailverified1 as "emailVerified" }